import { observer } from "mobx-react-lite"
import { Spin, Tabs, DatePicker} from "antd";
import { useStore } from "../../stores/root-store-context";
import TabPane from "antd/es/tabs/TabPane";
import dayjs, { Dayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { TimeReport } from "../../api/TimeReportsApiClient";
import { useTranslation } from "react-i18next";
import { UsersTime } from "./UsersTime";
import TimeReportsByDay from "./TimeReportsByDay";
import LeaveCalendar from './LeaveCalendar';

dayjs.extend(duration);

const { RangePicker } = DatePicker;

interface ByUserProps {
    setLogUserId: (id: string) => void,
    setLogProjectId: (id: string) => void,
    showModalAdd: () => void,
    showModalEdit: () => void,
    deleteTime: (id: string) => Promise<void>,
    setIsChangeUser: (status: boolean) => void,
    setEditTimeReport: (report: TimeReport) => void,
    timeReports: any[],
    startDate: Dayjs,
    endDate: Dayjs,
    setStartDate: (date: Dayjs) => void, 
    setEndDate: (date: Dayjs) => void,
    resetToCurrentMonth: () => void,
    setFullYearRange: () => void,
    activeUserTabKey: string;
    onUserTabChange: (key: string) => void;
    isAllTimeChecked: boolean;
    setIsAllTimeChecked: (checked: boolean) => void;  
}
  
  
const ByUser = observer(({
    setLogUserId,
    setLogProjectId,
    showModalAdd,
    showModalEdit,
    deleteTime,
    setIsChangeUser,
    setEditTimeReport,
    timeReports,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    resetToCurrentMonth,
    setFullYearRange,
    activeUserTabKey,
    onUserTabChange, 
    isAllTimeChecked, 
    setIsAllTimeChecked 
  }: ByUserProps)=> {
    const { timeReportStore} = useStore();
    const { t } = useTranslation();

    
    const handleUserTabChange = (key: string) => {
        onUserTabChange(key); 
        setIsAllTimeChecked(false);
        if (key === "vacationSickLeave") {
            setFullYearRange();
        } else {
            resetToCurrentMonth();
        }
    };

    return (
        <Spin spinning={timeReportStore.isLoading}>
            <Tabs activeKey={activeUserTabKey} onChange={handleUserTabChange}>
                <TabPane tab={t('TimeReports.UserActivity')} key="ByUser">
                    <UsersTime
                        setLogUserId={setLogUserId}
                        setLogProjectId={setLogProjectId}
                        showModalAdd={showModalAdd}
                        showModalEdit={showModalEdit}
                        deleteTime={deleteTime}
                        setIsChangeUser={setIsChangeUser}
                        setEditTimeReport={setEditTimeReport}
                        timeReports={timeReports}
                    />
                </TabPane>
                <TabPane tab={t('TimeReports.TimeOff')} key="vacationSickLeave">
                    <LeaveCalendar 
                        startDate={startDate}
                        endDate={endDate}
                        isAllTimeChecked={isAllTimeChecked}
                        setIsAllTimeChecked={setIsAllTimeChecked} 
                        onToggleAllTime={(newStartDate: dayjs.Dayjs, newEndDate: dayjs.Dayjs) => {
                            setStartDate(newStartDate);
                            setEndDate(newEndDate);
                        }}
                    />
                </TabPane>
                <TabPane tab={t('TimeReports.ByDay')} key="ByDay">
                <div style={{ 
                        width: "100vw",
                        marginLeft: "calc(-50vw + 50%)",
                        marginRight: "calc(-50vw + 50%)", 
                        paddingLeft: "0px",
                        paddingRight: "0px",
                        boxSizing: "border-box",
                    }}>
                    <TimeReportsByDay 
                        startDate={startDate} 
                        endDate={endDate}
                        setIsChangeUser={setIsChangeUser}
                        setEditTimeReport={setEditTimeReport}
                        showModalEdit={showModalEdit} 
                        deleteTime={deleteTime}/>
                        </div>
                </TabPane>
            </Tabs>
        </Spin>
    );
});
export default ByUser;